import { AdminTabs } from '../../admin/components/tabs';
import './style.css';
import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import Divider from '@/components/Divider';
import { SurveyDashboardTabs } from './tabs';
import SurveysResponsesQuestions from './surveys-responses-questions';
import SurveyDashboardSchoolsFilter from './schools-filter';
import { Caption } from './caption';
import { ToggleFilter } from './toggle-filter';
import { useSurveyDashboardStore } from '../store/useSurveyDashboard.store';
import SurveysResponsesCategories from './surveys-responses-categories';
import { SurveysNavigation } from './surveys-navigation';
import { ResponseTable } from './response-table';
import { AnimatePresence, motion } from 'framer-motion';
import {
  SurveyDashboardPage,
  SurveyDashboardPageQuery,
  SurveyDashboardPageQueryVariables,
} from '@/graphql/generated/graphql';
import { useQuery } from '@apollo/client';
import { QUERY_SURVEY_DASHBOARD_PAGE } from '@/graphql/queries/survey/survey-dashboard';
import { useEffect } from 'react';

export default function SurveyDashboard() {
  const { selectedComponent, currentTab, updatePage, page } = useSurveyDashboardStore((store) => {
    return {
      selectedComponent: store.selectedComponent,
      currentTab: store.currentTab,
      updatePage: store.updatePage,
      page: store.page,
    };
  });

  const { data } = useQuery<SurveyDashboardPageQuery, SurveyDashboardPageQueryVariables>(QUERY_SURVEY_DASHBOARD_PAGE, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    updatePage(data?.surveyDashboardPage?.data?.attributes as SurveyDashboardPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <AdminTabs />
      <Container className="rounded-2xl border border-primary-500 bg-white !p-5">
        <SubContainer className="!col-span-12 flex items-center justify-center text-center">
          <SurveysNavigation />
        </SubContainer>
        <div className="col-span-12">
          <SurveyDashboardSchoolsFilter />
        </div>

        <div className="col-span-12" style={{ display: 'block' }}>
          <div>
            <Divider className="!my-[15px]" />
          </div>
          <div>
            <SurveyDashboardTabs />
          </div>
          <div>
            <Divider className="!my-[15px] !-mt-[17px]" />
          </div>
          <div className="mb-[15px] flex min-h-[38px] flex-col-reverse gap-3 md:flex-row-reverse">
            <Caption />
            {currentTab === 'survey-responses' && <ToggleFilter />}
          </div>

          {/* Animate changes when selectedComponent updates */}
          {currentTab === 'survey-responses' && (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedComponent}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}>
                {selectedComponent === page?.toggle.questions ? (
                  <SurveysResponsesQuestions />
                ) : (
                  <SurveysResponsesCategories />
                )}
              </motion.div>
            </AnimatePresence>
          )}

          {/* Animate changes when currentTab is response-table */}
          {currentTab === 'response-table' && (
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTab} // key can also be a static string if response-table is the only key here
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}>
                <ResponseTable />
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      </Container>
    </>
  );
}
